import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from 'react-responsive';

import { colors } from '../../constant';
import {
  CloseModalImg,
  ModalBasic,
  ModalBody,
  ModalFooter,
  ModalHeader
} from '../../common/modal/Modal';
import Input from '../../common/input/Input';
import Button from '../../common/button/Button';
import Text from '../../common/text/Text';
import Title from '../../common/title/Title';
import Box from '../../common/box/Box';
import CloseModalIcon from '../../../assets/icons/x.svg';
import { mobile } from '../../../constants/breakpoints';

export function ConfirmComplianceMode({
  title,
  text,
  retentionTime,
  timeScale,
  open,
  close,
  onSubmit,
  complainceText,
  isLoading
}) {
  const { t } = useTranslation();
  const translatedTimeScale = timeScale === 'Day(s)' ? t('days') : t('years');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const isMobile = useMediaQuery({ query: `(max-width: ${mobile}px)` });
  const onChange = e => {
    setConfirm(e.target.value);
  };

  useEffect(() => {
    if (!open) {
      setConfirm('');
      setError('');
    }
  }, [open]);

  const handleSubmit = e => {
    e.preventDefault();
    if (error.length === 0) {
      onSubmit();
    }
  };

  return (
    <ModalBasic
      style={{ width: '420px' }}
      open={open}
      closeModal={close}
      // eslint-disable-next-line react/no-children-prop
      children={<Input />}
    >
      <div>
        <ModalHeader>
          <Title fontSize="18px" fontWeight="500" color={colors.black}>
            {title}
          </Title>
          <CloseModalImg src={CloseModalIcon} onClick={close} />
        </ModalHeader>

        <ModalBody>
          <Text mb="20px" fontSize="14px" fontWeight="400">
            {t('objectsRemainImmutable', { text: text })}{' '}
            <Text fontWeight="500" display="inline-flex">
              {retentionTime} {translatedTimeScale}{' '}
            </Text>
            . {complainceText}
          </Text>
          <nobr>
            <Text display="inline" mb="10px" fontSize="14px" fontWeight="400">
              {t('firstType')}{' '}
              <Text fontWeight="500" display="inline-flex">
                &apos;{t('confirmUpper')}&apos;
              </Text>{' '}
              {t('toProceed')}
            </Text>
          </nobr>
        </ModalBody>

        <ModalFooter
          mt="10px"
          width="100%"
          display="flex"
          alignitems="flex-start"
        >
          <Box display="flex" direction="column" w="100%" mr="20px">
            <Input
              marginBottom="0"
              width={isMobile ? '90%' : 'auto'}
              borderColor="#F5F6F8"
              fontSize="14px"
              value={confirm}
              onChange={onChange.bind(this)}
            />
          </Box>

          <Button
            isLoading={isLoading}
            color={colors.white}
            bordercolor="transparent"
            primary
            onClick={handleSubmit}
            className={
              confirm.length === 0 || error.length > 0 ? 'confirm' : 'confirm'
            }
            disabled={confirm !== t('confirmUpper') || error.length > 0}
          >
            {t('confirm')}
          </Button>
        </ModalFooter>
      </div>
    </ModalBasic>
  );
}

ConfirmComplianceMode.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  retentionTime: PropTypes.string.isRequired,
  timeScale: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  complainceText: PropTypes.string.isRequired,
  isLoading: PropTypes.string.isRequired
};
